import {
  Box,
  SimpleGrid,
} from "@chakra-ui/react";

// Custom components
import MiniStatistics from "components/card/MiniStatistics";
import IconBox from "components/icons/IconBox";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { masterDashboard } from "../../../redux/actions/Admin.action";
import { LuIndianRupee, LuUser } from "react-icons/lu";
import { Link } from 'react-router-dom';
import { GiMedicines } from "react-icons/gi";
import { TbReportOff } from "react-icons/tb";
import { useState } from "react";

export default function UserReports() {

  const dispatch = useDispatch()
  const counts = useSelector((state) => state.admin)
  const CountData = counts?.masterCount?.data

  const getTodayDate = () => new Date().toISOString().split("T")[0];
  const getCurrentMonth = () => new Date().toISOString().slice(0, 7);

  const [date, setDate] = useState(getTodayDate());
  const [month, setMonth] = useState(getCurrentMonth());
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const handleDateChange = (e) => setDate(e.target.value);
  const handleMonthChange = (e) => setMonth(e.target.value);
  const handleStartDateChange = (e) => setStartDate(e.target.value);
  const handleEndDateChange = (e) => setEndDate(e.target.value);

  useEffect(() => {
    dispatch(masterDashboard(date, month, startDate, endDate));
  }, [dispatch, date, month, startDate, endDate]);

  const data = {
    labels: ['Total Appointment', 'Confirm Appointment', 'Pending Appointment'],
    datasets: [
      {
        label: "Amount",
        data: [
          CountData?.totalAppointments || 0,
          CountData?.confirmedAppointments || 0,
          CountData?.pendingAppointments || 0,
        ],
        backgroundColor: 'rgba(183, 130, 52,0.6)',
        borderColor: 'rgba(183, 130, 52,0.6)',
        borderWidth: 1,
      },
    ]
  };
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    aspectRatio: 2,
    plugins: {
      legend: {
        position: 'top',
      },
      title: {
        display: true,
        text: 'All Amounts',
      },
    },
  };

  return (
    <>
      <div className="flex items-center justify-end gap-2">
        <div className='w-[200px] mt-[100px]'>
          <label className="text-sm block mb-1">Month</label>
          <input
            type="month"
            name="month"
            value={month}
            onChange={handleMonthChange}
            className="w-75 outline-none !border-b"
          />
        </div>
        <div className='w-[200px] mt-[100px]'>
          <label className="text-sm block mb-1">Start Date</label>
          <input
            type="date"
            name="startdate"
            value={startDate}
            onChange={handleStartDateChange}
            className="w-75 outline-none !border-b"
          />
        </div>
        <div className='w-[200px] mt-[100px]'>
          <label className="text-sm block mb-1">End Date</label>
          <input
            type="date"
            name="enddate"
            value={endDate}
            onChange={handleEndDateChange}
            className="w-75 outline-none !border-b"
          />
        </div>
        <div className='w-[200px] mt-[100px]'>
          <label className="text-sm block mb-1">Date</label>
          <input
            type="date"
            name="date"
            value={date}
            onChange={handleDateChange}
            className="w-75 outline-none !border-b"
          />
        </div>
      </div>
      <Box pt={'50px'}>
        <SimpleGrid
          columns={{ base: 1, md: 2, lg: 3, "2xl": 4 }}
          gap='20px'
          mb='20px'>
          <Link to="/master/SalesReport">
            <MiniStatistics
              startContent={
                <IconBox
                  w='56px'
                  h='56px'
                  className='text-theme-dark bg-[#F7EEE9]'
                  icon={
                    <LuIndianRupee className="text-[24px]" />
                  }
                />
              }
              name='Total Today Amount'
              value={CountData?.todaySales?.toFixed(2)}
            />
          </Link>
          <Link to="/master/SalesReport">
            <MiniStatistics
              startContent={
                <IconBox
                  w='56px'
                  h='56px'
                  className='text-theme-dark bg-[#F7EEE9]'
                  icon={
                    <LuIndianRupee className="text-[24px]" />
                  }
                />
              }
              name='Total Bill Amount'
              value={CountData?.monthSales?.toFixed(2)}
            />
          </Link>
          <Link to={"/master/PatientMaster"}>
            <MiniStatistics
              startContent={
                <IconBox
                  w='56px'
                  h='56px'
                  className='text-theme-dark bg-[#F7EEE9]'
                  icon={
                    <LuUser className="text-[24px]" />
                  }
                />
              }
              name='Total Patient'
              value={CountData?.totalPatients}
            />
          </Link>
          <Link to={"/master/ProductMaster"}>
            <MiniStatistics
              startContent={
                <IconBox
                  w='56px'
                  h='56px'
                  className='text-theme-dark bg-[#F7EEE9]'
                  icon={
                    <GiMedicines className="text-[24px]" />
                  }
                />
              }
              name='Total Medicine'
              value={CountData?.totalMedicines}
            />
          </Link>
          <Link to={"/master/LowReport"}>
            <MiniStatistics
              startContent={
                <IconBox
                  w='56px'
                  h='56px'
                  className='text-theme-dark bg-[#F7EEE9]'
                  icon={
                    <TbReportOff className="text-[24px]" />
                  }
                />
              }
              name='Total Minus Product'
              value={CountData?.minusStock}
            />
          </Link>
        </SimpleGrid>
      </Box>
      <div className="mt-5 chart-wrapper md:w-[60%] mx-auto">
        {/* <BarChart data={data} options={options} /> */}
        {/* <LineChart month={CountData?.monthSales}/> */}
      </div>
    </>
  );
}
